import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line prefer-destructuring
var CORVETTE_HOST = process.env.CORVETTE_HOST;
export var SigninRefPath;
(function (SigninRefPath) {
  SigninRefPath["boostOnboarding"] = "/mfe/cpd/boost/onboarding";
  SigninRefPath["carGarage"] = "/mfe/member/auto-garage/detail";
  SigninRefPath["creditCards"] = "/mfe/member/credit-cards/offers";
  SigninRefPath["noDingCreditCards"] = "/mfe/member/credit-cards/offers?efp=applywithconfidence";
  SigninRefPath["creditReport"] = "/mfe/credit/report/experian/now";
  SigninRefPath["creditHub"] = "/mfe/credit/credithub/experian";
  SigninRefPath["creditLock"] = "/mfe/regulatory/credit-lock";
  SigninRefPath["darkWebScan"] = "/identity/activity?scantype=t";
  SigninRefPath["finRecurringPayment"] = "/mfe/member/finances/recurring-payments";
  SigninRefPath["insuranceHub"] = "/mfe/member/insurance/hub";
  SigninRefPath["monCreateAccount"] = "/mfe/money/create-account";
  SigninRefPath["personalLoans"] = "/mfe/member/loans/personal-loans";
  SigninRefPath["protection"] = "/mfe/protection/protection-center";
  SigninRefPath["smartMoneyOnboarding"] = "/mfe/money/onboarding";
  SigninRefPath["securityFreeze"] = "/mfe/regulatory/security-freeze";
  SigninRefPath["studentLoan"] = "/mfe/member/loans/student-loans";
  SigninRefPath["unifiedAlerts"] = "/mfe/member/unifiedalerts/all";
  SigninRefPath["upgrade"] = "/mfe/member/upgrade";
})(SigninRefPath || (SigninRefPath = {}));
export var CTApath;
(function (CTApath) {
  CTApath["registration"] = "/registration";
  CTApath["getStarted"] = "/registration/getStarted";
  CTApath["loginIndex"] = "/login/index";
  CTApath["mobileMatchGetStarted"] = "/registration/mobile-match/get-started";
})(CTApath || (CTApath = {}));
export var formCTAurl = function formCTAurl(params) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CTApath.getStarted;
  var defaultParams = {
    br: 'exp'
  };
  var fullUrl = url.includes('.') ? new URL(url) : new URL("".concat(CORVETTE_HOST).concat(url));
  var existingParamsOfTheUrl = new URLSearchParams(fullUrl.search);
  var allParams = _objectSpread(_objectSpread({}, defaultParams), params);
  Object.entries(allParams).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    existingParamsOfTheUrl.set(key, value);
  });
  fullUrl.search = existingParamsOfTheUrl.toString();
  return fullUrl.toString();
};